export type Matcher<K, V> = (key: K) => V;

// Enables the creation of pattern matchers simplifying the mapping of one data type
// to another
export default function match<K, V>(
  ...patterns: Array<[K[] | K, V]>
): Matcher<K, V> {
  return (key: K) => {
    for (const [k, v] of patterns) {
      if (k === key || (Array.isArray(k) && k.includes(key))) {
        return v;
      }
    }

    throw new Error(`Non exhaustive match, no match for "${key}"`);
  };
}
